import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Switch } from "@progress/kendo-react-inputs";
import _ from "lodash";
import React from "react";
import { toLocalDateTime } from "../../../../HelperMethods";

export interface SettingFieldsProps {
    data?: any;
    onHandleChange?: any;
}

export interface SettingFieldsState {
    inputBoxData?: any;
    dropDownData?: any;
    CheckBoxData?: boolean;
}

export default class SettingFields extends React.Component<
    SettingFieldsProps,
    SettingFieldsState
> {
    changed;
    constructor(props) {
        super(props);
        this.state = {
            CheckBoxData: false,

        }
    }

    componentDidMount() {
        if (document.getElementsByName('effectiveDate')) {
            document.getElementsByName('effectiveDate')[0]['disabled'] = true;
            document.getElementsByName('effectiveDate')[1]['disabled'] = true;
            document.getElementsByName('effectiveDate')[2]['disabled'] = true;
        }
    }

    handleChange = (value, field) => {
        var fieldValue = value;
        if (field == "dateBoxData") {
            fieldValue = toLocalDateTime(value)
        }
        if (field == "CheckBoxData") {
            this.props.onHandleChange({ value: this.props.data.value == "true" ? "false" : "true", settingId: this.props.data.settingId })
        } else {
            this.props.onHandleChange({ value: fieldValue, settingId: this.props.data.settingId })
        }
    };

    renderDropDown = () => {
        let data = this.props.data.listOption.split(',')
        console.log("data", data, this.props.data.listOption)
        return (
            <DropDownList
                data={data}
                value={this.props.data.value}
                onChange={(e) => this.props.onHandleChange({ value: e.target.value, settingId: this.props.data.settingId })}
                className="form-control mr-3"
            />
        );
    };
    renderRadio = () => {
        return (
            <div style={{ width: "20px", height:"20px"}}>
                <label className="container-R d-flex mb-0 pb-3">
                    <input
                        type="checkbox"
                        checked={this.props.data.value == "true" ? true : false}
                        onChange={(e) => this.handleChange(e, "CheckBoxData")}
                        className="pl-2"
                    />
                    <span className="checkmark-R checkPosition checkPositionTop" style={{ left: "0px" }}></span>
                </label>
            </div>
        );
    };
    renderTextField = (type) => {
        return (
            <input
                type={type == "decimal" ? "number" : type}
                maxLength={2000}
                className={type == "number"? "form-control text-right": "form-control"}
                value={this.props.data.value == null ? "" : this.props.data.value}
                onChange={(e) => this.handleChange(e.target.value, "inputBoxData")}
                placeholder={type == "decimal" ? '0.00' : null}
            />
        );
    };
    renderToggle = ()=>{
        return(
            <div>
                 <Switch 
                  checked={this.props.data.value == "true" ? true : false}
                  onChange={(e) => this.handleChange(e, "CheckBoxData")}
                  />
            </div>
        )
    }
    renderTextArea = () => {
        return (
            <div>
                <textarea
                    rows={4}
                    id=""
                    maxLength={2000}
                    value={this.props.data.value == null ? "" : this.props.data.value}
                    className="form-control"
                    onChange={(e) => this.handleChange(e.target.value, "inputBoxData")}
                />
            </div>
        )
    }
    renderDatePicker = () => {
        return (
            <DatePicker
                className="form-control"
                format="MM/dd/yyyy"
                name="effectiveDate"
                value={this.props.data.value != undefined && this.props.data.value !== null ? new Date(this.props.data.value) : null}
                onChange={(e) => this.handleChange(e.target.value, "dateBoxData")}
                formatPlaceholder="formatPattern"
            />
        );
    };

    renderSwitch(param) {
        switch (param) {
            case 'text':
                return this.renderTextField(param);
            case 'decimal':
                return this.renderTextField(param);
            case 'number':
                return this.renderTextField(param);
            case 'boolean':
                return this.renderRadio();
            case 'list':
                return this.renderDropDown();
            case 'switch':
                return this.renderToggle();
            case 'textarea':
                return this.renderTextArea();
            case 'date':
                return this.renderDatePicker();
            default:
                return '';
        }
    }

    render() {
        const { data } = this.props;
        return (
            <>
                {this.renderSwitch(data.settingDataType)}
            </>
        );
    }
}
